import { render, staticRenderFns } from "./CaptureForm.vue?vue&type=template&id=b95ac396&scoped=true&"
import script from "./CaptureForm.vue?vue&type=script&lang=js&"
export * from "./CaptureForm.vue?vue&type=script&lang=js&"
import style0 from "./CaptureForm.vue?vue&type=style&index=0&id=b95ac396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95ac396",
  null
  
)

export default component.exports